import { useState } from 'react';
import { useFormik } from 'formik';
import { LOGIN_FORM_INIT_VALUES } from '../../constants/auth';
import { FormInput } from '../FormInput/FormInput';
import { Button } from '../Button/Button';
import { Form } from '../Form/Form';
import { Copy } from '../../copy/Copy';
import { useTheme } from '@mui/material';
import {
  marginTop16Sx,
  buttonSx,
  centerText16pxMarginSx,
  centerTextSx,
  font500Sx,
} from '../../styles/Global.style';
import { useAuth } from '../../hooks/useAuth/useAuth';
import { HelperLink } from '../HelperLink/HelperLink';
import { FormContainer } from '../../containers/FormContainer/FormContainer';
import { LOGIN_FORM_VALIDATION_SCHEMA } from '../../validation/auth';
import { Password } from '../Password/Password';
import { useNavigate } from 'react-router-dom';
import { APP_PATHS } from '../../constants/paths';

export const LoginForm = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [message, setMessage] = useState();
  const [isError, setIsError] = useState(false);
  const LOGIN = Copy.generate('Global.login');

  const resetError = () => {
    setTimeout(() => {
      setMessage('');
      setIsError(false);
    }, 3000);
  };

  const formik = useFormik({
    initialValues: LOGIN_FORM_INIT_VALUES,
    validationSchema: LOGIN_FORM_VALIDATION_SCHEMA,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (val) => {
      try {
        await signIn(val.email.toLowerCase(), val.password);
        navigate(APP_PATHS.profile);
      } catch (err) {
        setIsError(true);
        setMessage(err.message);
        resetError();
      }
    },
  });

  return (
    <FormContainer title={LOGIN}>
      <Form formik={formik} isError={isError} message={message}>
        <FormInput
          inputFor="email"
          formik={formik}
          labelText={Copy.generate('Inputs.email')}
          inputType="email"
        />
        <Password formik={formik} />
        <Button
          type="submit"
          fullWidth
          text={LOGIN}
          sx={{ ...buttonSx(theme), ...marginTop16Sx }}
        />
      </Form>

      {!isError && (
        <>
          <HelperLink
            to={APP_PATHS.register}
            textIdentifier="Links.register"
            linkText={Copy.generate('Global.signUp')}
            sx={{
              ...font500Sx,
              ...centerText16pxMarginSx,
            }}
          />
          <HelperLink
            to={APP_PATHS.resetPassword}
            textIdentifier="Links.resetPassword"
            linkText={Copy.generate('Global.forgotPassword')}
            sx={{
              ...font500Sx,
              ...centerTextSx,
            }}
          />
        </>
      )}
    </FormContainer>
  );
};
